let returnPhasesOfTree : any;
export default returnPhasesOfTree = ( Data: any ) => {
  console.log( 'data', Data );
    // const { responseObject }: { responseObject: any } = Data;
    // const { coursePlan }: { coursePlan: any } = responseObject;
    const { phases }: { phases: any } = Data;
    return phases;
  }
  